import { createSlice } from "@reduxjs/toolkit"
import { addOffer, getActiveOffer, getAllOffer, getAllOfferCount, getInActiveOffer, getOffer, toggleOfferStatus, updateOffer } from "../actions/offer";

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    allOfferList: [],
    singleOffer: null,
    allOfferCount: 0,
    inActiveOffer: 0,
    activeOffer: 0,
    total: 0,
}

export const brandSlice = createSlice({
    name: "brand",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {
        //========================
        // Add offer
        //==========================
        builder.addCase(addOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(addOffer.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(addOffer.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all offer with pagination
        //=================================
        builder.addCase(getAllOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllOffer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allOfferList = action.payload.data?.data;
            state.total = action.payload.data?.total
        });
        builder.addCase(getAllOffer.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get single offer
        //===========================
        builder.addCase(getOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getOffer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleOffer = action.payload.data?.offer;
        });
        builder.addCase(getOffer.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get all offer count
        //===========================
        builder.addCase(getAllOfferCount.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllOfferCount.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allOfferCount = action.payload.data?.offer;
        });
        builder.addCase(getAllOfferCount.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get inActive offer
        //===========================
        builder.addCase(getInActiveOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getInActiveOffer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.inActiveOffer = action.payload.data?.inActiveOffer;
        });
        builder.addCase(getInActiveOffer.rejected, (state) => {
            state.isError = true;
        });


        //===========================
        //Get active offer
        //===========================
        builder.addCase(getActiveOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getActiveOffer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.activeOffer = action.payload.data?.activeOffer;
        });
        builder.addCase(getActiveOffer.rejected, (state) => {
            state.isError = true;
        });

        //============================
        // toggle brand status
        //============================
        builder.addCase(toggleOfferStatus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(toggleOfferStatus.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(toggleOfferStatus.rejected, (state) => {
            state.isError = true;
        });

        //==============================
        //update offer
        //=============================
        builder.addCase(updateOffer.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateOffer.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(updateOffer.rejected, (state) => {
            state.isError = true;
        });

    }
})

export default brandSlice.reducer;